export const getSenderDistricts = async (senderTownID) => {
    let error = null
    const resp = await fetch(`/api/find-districts?town_id=${senderTownID}`).catch((err) => {
        error = err
        console.log(err)
    })
    const data = await resp.json().catch((err) => {
        error = err
        console.log(err)
    })

    if (!data || error || data.err) {
        return null
    }

    return data.output
};